import React from "react";
import "../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col } from "react-bootstrap";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://github.com/Saumya-09"
                style={{ color: "white" }}
              >
                <i className="fab fa-github"></i>
              </a>
            </li>
            <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/saumyaabhatt/"
                  target="_blank"
                  rel="noreferrer"
                  //className="icon-colour  home-social-icons"
                >
                  <i className="fab fa-linkedin"></i>
                </a>
              </li>
            <li className="social-icons">
              <a
                  href="mailto:bhatt.saumya.09@gmail.com"
                  style={{ color: "white" }}
              >
                  <i className="fas fa-envelope"></i>
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
